/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SupportCaseDto = {
    id?: string;
    shopId?: string;
    shopName?: string;
    title?: string;
    description?: string;
    status?: SupportCaseDto.status;
    createdBy?: string;
    caseDetailUrl?: string;
    caseMenu?: string;
    createdAt?: string;
    updatedAt?: string;
};
export namespace SupportCaseDto {
    export enum status {
        OPEN = 'OPEN',
        IN_PROGRESS = 'IN_PROGRESS',
        RESOLVED = 'RESOLVED',
        CANCEL = 'CANCEL',
        REOPEN = 'REOPEN',
    }
}

